import { DrawablyCard, DrawablyDivider, DrawablyHighlight } from 'drawably/react';
import { BadgeCheck, BadgeAlert, BadgeHelp, BadgeX, Bird } from 'lucide-react';
import { useEffect, useState } from 'react';

const PopUpsColors = {
    info: '#2b26d0',
    success: '#0f766e',
    warning: '#ffda0a',
    error: '#ce0606',
};

const PopUp = ({ type, title, content, duration, className = '' }) => {
    const [fadeInOut, setFadeInOut] = useState(false);
    useEffect(() => {
        const timeout = setTimeout(
            () => {
                setFadeInOut(true);
            },
            (duration - 1) * 1000,
        );
        return () => clearTimeout(timeout);
    }, [duration]);
    return (
        <DrawablyCard
            stroke={PopUpsColors[type] || PopUpsColors.info}
            className={`anikino__popup${type ? ` ${type}` : ''}${className ? ` ${className}` : ''}${fadeInOut ? ' hide' : ''}`}
        >
            <DrawablyHighlight
                roughness={2}
                boil={0.2}
                stroke={PopUpsColors[type] || PopUpsColors.info}
                className={`anikino__popup-content${type ? ` ${type}` : ''}`}
            >
                {type === 'error' ? (
                    <BadgeX className="anikino__popup-content-svg" />
                ) : type === 'warning' ? (
                    <BadgeAlert className="anikino__popup-content-svg" />
                ) : type === 'success' ? (
                    <BadgeCheck className="anikino__popup-content-svg" />
                ) : type === 'help' ? (
                    <BadgeHelp className="anikino__popup-content-svg" />
                ) : type === 'info' ? (
                    <Bird className="anikino__popup-svg" />
                ) : (
                    ''
                )}
                <DrawablyDivider />
                <div className={`anikino__popup-textbox${type ? ` ${type}` : ''}`}>
                    <h2 className="anikino__popup-textbox-title">{title}</h2>
                    <p className="anikino__popup-textbox-text">{content}</p>
                </div>
            </DrawablyHighlight>
        </DrawablyCard>
    );
};

export default PopUp;
